"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialAvailability = exports.getHighlights = exports.getAvailability = void 0;
const getHighlights = option => option.connections;
exports.getHighlights = getHighlights;
const getFullAvailability = variantGroups => variantGroups.reduce((acc, currentGroup) => ({
  ...acc,
  [currentGroup.id]: currentGroup.options.map(option => option.value)
}), {});
const getInitialAvailability = variantGroups => {
  if (variantGroups.length !== 2) {
    return getFullAvailability(variantGroups);
  }
  return variantGroups.reduce((acc, currentGroup) => {
    const selectedOption = currentGroup.options.find(o => o.isSelected);
    if (selectedOption) {
      return {
        ...acc,
        ...selectedOption.connections
      };
    }
    return {
      ...acc,
      ...{
        ...currentGroup.options[0].connections
      }
    };
  }, {});
};
exports.getInitialAvailability = getInitialAvailability;
const getAvailability = (variantGroups, option, groupId) => {
  if (variantGroups.length !== 2) {
    return getFullAvailability(variantGroups);
  }
  const currentGroup = variantGroups.find(group => group.id === groupId);
  return {
    ...option.connections,
    [currentGroup.id]: currentGroup.options.map(o => o.value)
  };
};
exports.getAvailability = getAvailability;
//# sourceMappingURL=utils.js.map